import { can, canAny, type User } from '../../lib/types'

export type ConfigTab = 'activities' | 'products' | 'calendar' | 'org' | 'otp'

const GATES: { key: ConfigTab; visible: (user: User | undefined) => boolean }[] = [
  { key: 'activities', visible: (u) => can(u, 'time.admin') },
  { key: 'products', visible: (u) => can(u, 'hr.edit') },
  { key: 'calendar', visible: (u) => can(u, 'time.admin') || can(u, 'calendar.edit') },
  { key: 'org', visible: (u) => can(u, 'admin') },
  { key: 'otp', visible: (u) => Boolean(u?.is_admin) },
]

/** Whether `/admin/config` opens for this viewer: an admin, or whoever keeps the holiday calendar. */
export function mayOpenConfig(user: User | undefined): boolean {
  return can(user, 'admin') || can(user, 'calendar.edit')
}

/** Whether the calendar tab may fetch the pay dates, which the server gives anyone who reaches it. */
export function seesPayDates(user: User | undefined): boolean {
  return canAny(user, ['time.admin', 'salary.view', 'calendar.edit'])
}

/** The Config tabs this viewer sees, in page order. */
export function configTabs(user: User | undefined): ConfigTab[] {
  return GATES.filter((gate) => gate.visible(user)).map((gate) => gate.key)
}
